import styled from 'styled-components';

export const UamMessagePanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px 0px;
`;

export const UamMessagePanelTitle = styled.h2`
  font-size: 1.125rem;
  margin-bottom: 10px;
`;

export const UamMessagePanelMessage = styled.div`
  font-size: 1rem;
  margin-bottom: 10px;
`;